module.exports = __webpack_public_path__ + "img/chat-24px.595aa258.svg";